// @flow

export default (props) => {
  switch (props.decorator || props.is) {
    case 'SelectDesign':
      return import('./components/SelectDesign');
    case 'TriggerInViewport':
      return import('./components/TriggerInViewport');
    case 'LazyImage':
      return import('./components/LazyImage');
    case 'Toggler':
      return import('./components/Toggler');
    case 'Accordion':
      return import('./components/Accordion');
    case 'ShowMorePhotos':
      return import('./components/ShowMorePhotos');
    case 'AddSvgIconSprite':
      return import('./components/AddSvgIconSprite');
    case 'PhotoSwipe':
      return import('./components/PhotoSwipe');
    case 'Form':
      return import('./components/Form');
    case 'InformationBar':
      return import('./components/InformationBar');
    case 'InquiryBar':
      return import('./components/InquiryBar');
    case 'Header':
      return import('./components/Header');
    case 'LangSwitch':
      return import('./components/LangSwitch');
    case 'ImageParallax':
      return import('./components/ImageParallax');
    case 'AnchorSlider':
      return import('./components/AnchorSlider');
    case 'AnimateInViewport':
      return import('./components/AnimateInViewport');
    case 'UniversalPaginationButton':
      return import('fg-frontend/components/UniversalPaginationButton');
    case 'FullpageGallery':
      return import('./components/FullpageGallery');
    case 'AnchorMenu':
      return import('./components/AnchorMenu');
    case 'Sidebar':
      return import('./components/Sidebar');
    case 'VideoModal':
      return import('./components/VideoModal');
    case 'AdvancedSwiper':
      return import('./components/AdvancedSwiper');
    case 'NumberInput':
      return import('fg-frontend/components/NumberInput');
    case 'GoogleMapContacts':
      return import('./components/GoogleMapContacts');
    case 'RangeDatepicker':
      return import('./components/RangeDatepicker');
    case 'YouTubeVideo':
      return import('./components/YouTubeVideo');
    case 'PageTopSlider':
      return import('./components/PageTopSlider');
    case 'Testimonial':
      return import('./components/Testimonial');
    case 'GoogleRecaptcha':
      // COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
      return import('fg-frontend/src/components/GoogleRecaptcha');
    default:
        console.log(`Unknown component ${props.decorator || props.is}`);
        return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js